export const India = [
  {
    city: "Agra",
  },
  {
    city: "Ahmedabad",
  },
  {
    city: "Alwar",
  },
  {
    city: "Amritsar",
  },
  {
    city: "Aurangabad",
  },
  {
    city: "Bangalore",
  },
  {
    city: "Bhopal",
  },
  {
    city: "Bhubaneswar",
  },
  {
    city: "Chandigarh Tricity",
  },
  {
    city: "Chennai",
  },
  {
    city: "Coimbatore",
  },
  {
    city: "Cuttack",
  },
  {
    city: "Dehradun",
  },
  {
    city: "Delhi NCR",
  },
  {
    city: "Guntur",
  },
  {
    city: "Guwahati",
  },
  {
    city: "Gwalior",
  },
  {
    city: "Hyderabad",
  },
  {
    city: "Indore",
  },
  {
    city: "Jabalpur",
  },
  {
    city: "Jaipur",
  },
  {
    city: "Jamshedpur",
  },
  {
    city: "Jodhpur",
  },
  {
    city: "Kakinada",
  },
  {
    city: "Kanpur",
  },
  {
    city: "Karnal",
  },
  {
    city: "Kochi",
  },
  {
    city: "Kolkata",
  },
  {
    city: "Kota",
  },
  {
    city: "Lucknow",
  },
  {
    city: "Ludhiana",
  },
  {
    city: "Madurai",
  },
  {
    city: "Meerut",
  },
  {
    city: "Mumbai",
  },
  {
    city: "Mysore",
  },
  {
    city: "Nagpur",
  },
  {
    city: "Nashik",
  },
  {
    city: "Panipat",
  },
  {
    city: "Patna",
  },
  {
    city: "Prayagraj",
  },
  {
    city: "Pune",
  },
  {
    city: "Raipur",
  },
  {
    city: "Rajahmundry",
  },
  {
    city: "Ranchi",
  },
  {
    city: "Rohtak",
  },
  {
    city: "Sonipat",
  },
  {
    city: "Surat",
  },
  {
    city: "Thiruvananthapuram",
  },
  {
    city: "Udaipur",
  },
  {
    city: "Vadodara",
  },
  {
    city: "Varanasi",
  },
  {
    city: "Vijayawada",
  },
  {
    city: "Visakhapatnam",
  },
  {
    city: "Warangal",
  },
];
